import React from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import Card from '../../../components/Cards/Card';
import CashIcon from '../../../components/Icons/CashIcon';
import CurrentIcon from '../../../components/Icons/CurrentIcon';
import LineChartIcon from '../../../components/Icons/LineChartIcon';
import { useAppSelector } from '../../../redux/store';
import { REVENUE_PRICE_MANAGEMENT } from '../../../routes/routeConstants';
import { formatNaira } from '../../../utils/utils';

const LookupOverview = () => {
  const navigate = useNavigate();
  const { lookupMetrics } = useAppSelector((state) => state.lookupMetricsData);
  const { currentConfigData } = useAppSelector(
    (state) => state.currentConfigData,
  );

  return (
    <Container>
      <CardTitle>LOOKUP OVERVIEW</CardTitle>
      <CardsContainer>
        {/* Card 1 */}
        <Card.Root padding='20px 20px'>
          <Card.Header>
            <LineChartIcon /> Total Revenue Generated
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {formatNaira(lookupMetrics?.totalRevenueGenerated ?? 0)}
            </Card.LargeNumber>
          </Card.Body>
        </Card.Root>

        {/* Card 2 */}
        <Card.Root padding='20px 20px'>
          <Card.Header>
            <CashIcon /> Weekly Lookup Revenue
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {lookupMetrics?.weeklyLookupRevenue ?? 0}
            </Card.LargeNumber>
          </Card.Body>
          <Card.StatsArea trend='constant'>
            <div>vs last week</div>
          </Card.StatsArea>
        </Card.Root>

        {/* Card 3 */}
        <Card.Root padding='20px 20px'>
          <Card.Header alignSelf='flex'>
            <CurrentIcon />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  fontWeight: '600',
                  fontSize: '20px',
                  lineHeight: '20px',
                  color: '#232222',
                }}
              >
                Lookup Price
              </div>
              <div>Configure lookup prices and bundles</div>
            </div>
            <StyledShowModalBtn
              onClick={() => navigate(`/${REVENUE_PRICE_MANAGEMENT}`)}
            >
              Set Price
            </StyledShowModalBtn>
          </Card.Header>

          <LookupFooter>
            <LookupFooterGroup>
              <LookupFooterGroupHeader>Current Price</LookupFooterGroupHeader>
              <LookupFooterGroupFooter>
                {formatNaira(currentConfigData?.unitPrice ?? 0)}
              </LookupFooterGroupFooter>
            </LookupFooterGroup>

            <LookupFooterGroup>
              <LookupFooterGroupHeader>No of bundles</LookupFooterGroupHeader>
              <LookupFooterGroupFooter>
                {currentConfigData?.pricingBundle?.length ?? 0}/5
              </LookupFooterGroupFooter>
            </LookupFooterGroup>
          </LookupFooter>
        </Card.Root>
      </CardsContainer>
    </Container>
  );
};

export default LookupOverview;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const CardsContainer = styled.div`
  /* display: flex; */
  display: grid;
  grid-template-columns: 1fr 1fr 1.83fr;
  gap: 16px;
  width: 100%;
`;

const CardTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 16px;
  line-height: 16px;
`;

const StyledShowModalBtn = styled.button`
  cursor: pointer;
  width: fit-content;
  border-radius: 5px;
  padding: 12px 19px;
  background-color: #232222;
  color: white;
  border: none;
  font-size: 14px;
  font-weight: 500;
  margin-left: auto;
`;

const LookupFooter = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
`;

const LookupFooterGroup = styled.div`
  display: 'flex';
  flex-direction: 'column';
`;

const LookupFooterGroupHeader = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #9ca3af;
`;

const LookupFooterGroupFooter = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: #5c5963;
`;
